import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=3c1279d8&scoped=true"
import script from "./UsersManagement.vue?vue&type=script&lang=js"
export * from "./UsersManagement.vue?vue&type=script&lang=js"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=3c1279d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1279d8",
  null
  
)

export default component.exports